/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Cockpit_Stat_Stock_SyncInputs */

const tr_landing_cockpit_stat_stock_sync = /** @type {(inputs: Landing_Cockpit_Stat_Stock_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`stok senk.`)
};

const en_landing_cockpit_stat_stock_sync = /** @type {(inputs: Landing_Cockpit_Stat_Stock_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`stock sync`)
};

const de_landing_cockpit_stat_stock_sync = /** @type {(inputs: Landing_Cockpit_Stat_Stock_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestandssync`)
};

const ru_landing_cockpit_stat_stock_sync = /** @type {(inputs: Landing_Cockpit_Stat_Stock_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`синхр. остатков`)
};

/**
* | output |
* | --- |
* | "stock sync" |
*
* @param {Landing_Cockpit_Stat_Stock_SyncInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_cockpit_stat_stock_sync = /** @type {((inputs?: Landing_Cockpit_Stat_Stock_SyncInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Cockpit_Stat_Stock_SyncInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_cockpit_stat_stock_sync(inputs)
	if (locale === "de") return de_landing_cockpit_stat_stock_sync(inputs)
	if (locale === "ru") return ru_landing_cockpit_stat_stock_sync(inputs)
	return tr_landing_cockpit_stat_stock_sync(inputs)
});